import { render, staticRenderFns } from "./Overzicht.vue?vue&type=template&id=594bcdf5"
import script from "./Overzicht.vue?vue&type=script&lang=js"
export * from "./Overzicht.vue?vue&type=script&lang=js"
import style0 from "./Overzicht.vue?vue&type=style&index=0&id=594bcdf5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports